import React, { Component } from 'react'

import CajaDecorator from 'decorators/caja/caja_decorator'
import BaseInput from '../base/base_input'

class TextInput extends Component {

	render() {
		return (
			<BaseInput {...this.props} lineHeight40={true} />
		)
	}
}

export default CajaDecorator(TextInput)
